import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useFetchOrganisations from 'hooks/useFetchOrganisations';

import type { RootState } from '../../../../redux/Store';

/**
 * The active organisation's default water rate (L/ha), from its settings
 * (`orgSetting.waterRate`), or null when it has none. Read from the
 * organisation list the workspace already loads, so no extra request.
 */
export const useOrgDefaultWaterRate = (): number | null => {
  const activeOrganisationId = useSelector(
    (state: RootState) => state.activeOrganisationReducer.organisationId
  );
  const { data: organisations = [] } = useFetchOrganisations();
  return useMemo(
    () =>
      organisations.find((org) => org.id === activeOrganisationId)?.orgSetting
        ?.waterRate ?? null,
    [organisations, activeOrganisationId]
  );
};
